import * as type from './type';
import util from 'common/js/util';

export default{
    //获取提交的采购单号列表
    [type.GET_PURCHASE_ORDER_NUMBER](context, option){
        util.post({
            params: {
                functionId: '',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //校验下单商品是否全部大件（物权转移方式拦截中小件）
    [type.CHECK_IS_OVERSIZED_GOODS](context, option){
        util.post({
            params: {
                functionId: 'checkDeliveryType'
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //查询履约日历
    [type.GET_CALENDAR_INFO](context, option){
      util.post({
          params: {
              functionId: 'queryCalendar',
              body: JSON.stringify(option.params)
          },
          sc(data){
              if(option && option.sc){
                  option.sc && option.sc(data);
              }
          },
          fc(data){
              if(option && option.fc){
                  option.fc && option.fc(data);
              }
          }
      });
  },
}



// WEBPACK FOOTER //
// ./src/store/confirm/actions.js